// extracted by mini-css-extract-plugin
export var primaryColor = "TitleDuoTone_primaryColor__Lbr7Q";
export var title = "TitleDuoTone_title__c+U1x";
export var wrapper = "TitleDuoTone_wrapper__rZlt6";